import React from 'react'
import { FormsAndDocuments } from '../src/components'
import Footers from '../src/components/Footer'
import Header from '../src/components/Header'

export default function ContactPage() {
  return (
    <>
      <Header />
      <div className="cure-inner-container">
        <FormsAndDocuments />
      </div>
      <Footers />
    </>
  )
}
